export const getAccessToken = () => {
  if (typeof window === "undefined") return ""
  const direct = localStorage.getItem("accessToken")
  if (direct) return direct
  const prefix = localStorage.getItem("keyprefix")
  if (!prefix) return ""
  const idUser = localStorage.getItem(`${prefix}.LastAuthUser`)
  if (!idUser) return ""
  return localStorage.getItem(`${prefix}.${idUser}.idToken`) || ""
}

const getRefreshToken = () => {
  if (typeof window === "undefined") return ""
  return localStorage.getItem("refreshToken") || ""
}

const decodePayload = (token) => {
  try {
    const [, payload] = token.split(".")
    if (!payload) return null
    return JSON.parse(atob(payload))
  } catch {
    return null
  }
}

export const isTokenExpired = (token) => {
  const payload = decodePayload(token)
  const exp = Number(payload?.exp || 0)
  if (!exp) return false
  return Date.now() >= exp * 1000
}

export const getValidAccessToken = () => {
  const token = getAccessToken()
  if (!token) return ""
  if (isTokenExpired(token)) return ""
  return token
}

let refreshInFlight = null

export const getApiBaseUrl = () => {
  const fromEnv = (
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_V2_BACKEND_URL ||
    ""
  ).replace(/\/+$/, "")
  if (fromEnv) return fromEnv
  if (process.env.NODE_ENV === "production") {
    throw new Error("REACT_APP_API_BASE_URL is required in production builds")
  }
  return "http://localhost:3000"
}

export const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken()
  if (!refreshToken) return ""
  if (refreshInFlight) return refreshInFlight

  refreshInFlight = (async () => {
    try {
      const res = await fetch(`${getApiBaseUrl()}/auth/refresh`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken })
      })
      if (!res.ok) return ""
      const data = await res.json()
      const accessToken = data?.accessToken || ""
      if (!accessToken) return ""
      localStorage.setItem("accessToken", accessToken)
      const prefix = localStorage.getItem("keyprefix")
      const idUser = prefix ? localStorage.getItem(`${prefix}.LastAuthUser`) : ""
      if (prefix && idUser) {
        localStorage.setItem(`${prefix}.${idUser}.idToken`, accessToken)
      }
      return accessToken
    } catch {
      return ""
    } finally {
      refreshInFlight = null
    }
  })()

  return refreshInFlight
}

export const getValidAccessTokenWithRefresh = async () => {
  const direct = getValidAccessToken()
  if (direct) return direct
  return refreshAccessToken()
}

const clearAuthStorage = () => {
  localStorage.removeItem("accessToken")
  localStorage.removeItem("refreshToken")
  const prefix = localStorage.getItem("keyprefix")
  const idUser = prefix ? localStorage.getItem(`${prefix}.LastAuthUser`) : ""
  if (prefix) {
    localStorage.removeItem("keyprefix")
    localStorage.removeItem(`${prefix}.LastAuthUser`)
    if (idUser) localStorage.removeItem(`${prefix}.${idUser}.idToken`)
  }
}

export const handleUnauthorized = (reason = "expired") => {
  if (typeof window === "undefined") return
  clearAuthStorage()
  const loginPath = "/auth/login"
  if (window.location.pathname !== loginPath) {
    window.location.assign(`${loginPath}?session=${encodeURIComponent(reason)}`)
  }
}

/** Amplify REST / axios-style 401 detection */
export const isUnauthorizedApiError = (error) => {
  const status =
    error?.response?.status ??
    error?._response?.statusCode ??
    error?.statusCode
  if (status === 401) return true
  const message = String(error?.message || error || "")
  return message.includes("401") || message.toLowerCase().includes("unauthorized")
}

/** Redirect to login once on expired/invalid API session */
export const handleApiAuthError = (error) => {
  if (!isUnauthorizedApiError(error)) return false
  handleUnauthorized("expired")
  return true
}

